  /* eslint-disable array-callback-return */
  /* eslint-disable react-hooks/exhaustive-deps */
  import {
    // TOAST_MESSAGE_SEVERITY_ERROR,
    setPageTitle,
    showToast,
  } from '../layout/layout.actions';
  import { connect } from 'react-redux';
  import { withRouter } from 'react-router-dom';
  import React, { useEffect, useState } from 'react';
  
  import { Box, Button, Checkbox, FormControlLabel, Grid, makeStyles, MenuItem, Paper, TextField, Typography } from '@material-ui/core';
import GooglePlacesAutocompleteComponent from 'common/form/googlePlacesAutocomplete.component';
import { getDistance } from 'utilities/googleMapsClient';
import { getAutoShipmentCost, getFlightPrice, getHomesalePriceByRegion, getPackLoadMovePrice, getTempLivingPriceByRegion, setEstimations } from './estimator.actions';
import { getBenefits } from './constants';
import SelectionsCostBar from './selectionsCostBar.component';
import { CostUnit, displayCost } from 'utilities/currencyFormatter';
import { getGsaPerDiem, getNationalGsaLodgingPerDiem, getNationalGsaMealPerDiem } from './estimatorDataRequests';
import LogoSpinner from 'common/logoSpinner.component';

import { PDFDownloadLink } from '@react-pdf/renderer'
import DownloadableDoc from './downloadableDoc.component';
import { exportToExcelWithStyles, getFinalMoveTravelCost, getGrossUpAmount, getTotalEstimateAmount, getTravelPartyCost } from './utils';

  const useStyles = makeStyles((theme) => ({
    textField: {
       maxWidth: '200px',
    },
    button: {
        width: 125,
        marginRight: '5px'
    },
    longButton: {
        width: 125,
        marginRight: '5px'
    },
    loadingOverlay :{
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        zIndex: 3,
        backgroundColor: 'rgba(0,0,0,0.3)', // controls black overlay opacity
        display: 'flex',
    },
  }));
  
  const ExportPage = (props) => {  
    const estimateId = props.match.params.estimateId ? parseInt(props.match.params.estimateId) : null;
    const estimateInfo = estimateId ? props.estimates.find((e) => e.estimateId === estimateId) : null;

    const [costEstimatePolicyId] = useState(estimateInfo ? estimateInfo.costEstimatePolicyId : null);
    const [reloPolicy, setReloPolicy] = useState(estimateInfo ? estimateInfo.reloPolicy : '');
    const [accompanyingAdults, setAccompanyingAdults] = useState(estimateInfo ? estimateInfo.accompanyingAdults : '');
    const [origin, setOrigin] = useState(estimateInfo ? estimateInfo.origin : '');
    const [destination, setDestination] = useState(estimateInfo ? estimateInfo.destination : '');
    const [transfereeName, setTransfereeName] = useState(estimateInfo ? estimateInfo.transfereeName : '');
    const [distance, setDistance] = useState(0);

    const [perDiemRate, setPerDiemRate] = useState(0);
    const [perDiemMealRate, setPerDiemMealRate] = useState(0);
    const [avgHomesalePrice, setAvgHomesalePrice] = useState(0);
    const [avgHomesalePriceOrigin, setAvgHomesalePriceOrigin] = useState(0);
    const [flightCost, setFlightCost] = useState(0);
    const [isUpdatingSelections, setIsUpdatingSelections] = useState(true);
    const [homefindingDays, setHomefindingDays] = useState(3);
    const [autoShipmentCost, setAutoShipmentCost] = useState(0);
    const [tempLivingDaysCost, setTempLivingDaysCost] = useState(0);
    const [packLoadCost, setPackLoadCost] = useState(0);
    const [thirtyDayStorageCost, setThirtyDayStorageCost] = useState(0);
    const [sixtyDayStorageCost, setSixtyDayStorageCost] = useState(0);

    const classes = useStyles();

    const getOptionCost = (opt, selectedOption) => {
        if (!opt) return 0;

        if (opt.optionNumber === 23) {
            return getFinalMoveTravelCost(opt, selectedOption, distance, estimateInfo.accompanyingAdults);
        }

        const allBenefits = getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance);
        const relevantBenefit = allBenefits.find((b) => b.benefitNumber === opt.benefitNumber);

        const savedReloAllowanceBenefit = estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 8);

        if (savedReloAllowanceBenefit && opt.optionNumber === 27) {
            return savedReloAllowanceBenefit.cost ? Number(savedReloAllowanceBenefit.cost) : 0;
        } else if (selectedOption && opt.customOption) {
            return selectedOption.customCost ? Number(selectedOption.customCost) : 0;
        } else if (selectedOption && selectedOption.customCost !== undefined && selectedOption.customCost !== null && selectedOption.customCost !== 0 && Number.isFinite(Number(selectedOption.customCost))) {
            // Return saved customCost if it exists and is not 0 (for non-custom benefits)
            return Number(selectedOption.customCost);
        } else if (selectedOption && selectedOption.selectionId && opt.optionNumber !== 11 && opt.optionNumber !== 13) {
            const selectionCost = (opt.selections && opt.selections.find((selection) => selection.selectionId === selectedOption.selectionId)) ? opt.selections.find((selection) => selection.selectionId === selectedOption.selectionId).cost : 0;

            // Homefinding - Lodging and meal per diem calculations
            if ((opt.optionNumber === 15 || opt.optionNumber === 31) && estimateInfo.topLevelInputFourId && estimateInfo.topLevelInputFourId !== 1) {
              if (estimateInfo.topLevelInputFourId === 2) {
                return selectionCost * 2;
              } else if (estimateInfo.topLevelInputFourId === 3 && estimateInfo) {
                return getTravelPartyCost(selectionCost, estimateInfo.accompanyingAdults);
              }
            // Final Trip - Lodging and meal per diem calculations
            } else if (opt.optionNumber === 24 || opt.optionNumber === 32) {
                return getTravelPartyCost(selectionCost, estimateInfo.accompanyingAdults);
            // HHG - Storage in transit calculations
            } else if (opt.optionNumber === 6) {
                if (selectionCost === 30) {
                  return thirtyDayStorageCost;
                } else {
                  return sixtyDayStorageCost;
                }
            } else {
              return selectionCost;
            }
        } else {
          if (opt.optionNumber === 17) {
            const perDiemSelectionId = (relevantBenefit && estimateInfo.savedBenefits && estimateInfo.savedBenefits.find((sb) => relevantBenefit.benefitNumber === sb.benefitNumber)) ? estimateInfo.savedBenefits.find((sb) => relevantBenefit.benefitNumber === sb.benefitNumber).options.find((opt) => opt.optionNumber === 15)?.selectionId : null;
            const numDaysBetweenFlights = perDiemSelectionId ? (perDiemSelectionId === 8 ? 1 : (perDiemSelectionId === 9 ? 2 : (perDiemSelectionId === 11 ? 4 : 3))) : 3;
            return 98.89 * numDaysBetweenFlights;
          } else if (opt.optionNumber === 1) {
            return packLoadCost;
          } else if (opt.optionNumber === 11) {
            let tempLivingDaysSelectionId = 1;
    
            if (estimateInfo.savedBenefits && estimateInfo.savedBenefits.length > 0 && estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 2)) {
              tempLivingDaysSelectionId = estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 2).options.find((opt) => opt.optionNumber === 11).selectionId;
            }
    
            return tempLivingDaysCost * tempLivingDaysSelectionId * 30;
          } else if (opt.optionNumber === 28 || opt.optionNumber === 29 || opt.optionNumber === 30) {
            return selectedOption.customCost ? Number(selectedOption.customCost) : 0;
          } else if (distance > 350 && opt.optionNumber === 14 && estimateInfo.topLevelInputFourId && estimateInfo.topLevelInputFourId !== 1) {
            if (estimateInfo.topLevelInputFourId === 2) {
              return opt.cost * 2;
            } else if (estimateInfo.topLevelInputFourId === 3 && estimateInfo) {
              return getTravelPartyCost(opt.cost, estimateInfo.accompanyingAdults);
            }
          // Temporary Living - Rental car days calculations
          } else if (opt.optionNumber === 13 && selectedOption && selectedOption.selectionId) {
            return opt.cost * selectedOption.selectionId;
          // Home Purchasing - Direct bill / reimbursement amount
          } else if (opt.optionNumber === 19) {
            if (estimateInfo.topLevelInputEight) {
                return estimateInfo.topLevelInputNine ? Number(estimateInfo.topLevelInputNine * 0.02) : 0;
            } else {
                return opt.cost;
            }
          // Home Sale - Reimbursement amount
          } else if (opt.optionNumber === 21) {
            if (estimateInfo.topLevelInputSix) {
                return estimateInfo.topLevelInputSeven ? Number(estimateInfo.topLevelInputSeven * 0.08) : 0;
            } else {
                return opt.cost;
            }
          } else {
            return opt.cost;
          }
        }
      }

    useEffect(() => {
        (async () => {
            setIsUpdatingSelections(true);

            const perDiemSelectionId = estimateInfo?.savedBenefits ? estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 3)?.options.find((opt) => opt.optionNumber === 15)?.selectionId : null;
            const numDaysBetweenFlights = perDiemSelectionId ? (perDiemSelectionId === 8 ? 1 : (perDiemSelectionId === 9 ? 2 : (perDiemSelectionId === 11 ? 4 : 3))) : 3;
            setHomefindingDays(numDaysBetweenFlights);

            if (destination && destination.city && destination.state) {
                const gsaResp = await getGsaPerDiem(destination.city, destination.state, '2025');
                const gsaDestinationState = gsaResp.rates[0].state;
                let gsaDestinationCity = gsaResp.rates[0].rate[0].city;

                const gsaNationalLodgingRate = await getNationalGsaLodgingPerDiem();
                const gsaNationalMealRate = await getNationalGsaMealPerDiem();

                let regionName = 'United States';
                if (gsaDestinationCity !== null && gsaDestinationState !== null) {
                    gsaDestinationCity = gsaDestinationCity.includes(' / ') ? gsaDestinationCity.split(' / ')[0] : gsaDestinationCity;
                    regionName = `${gsaDestinationCity}, ${gsaDestinationState}`;
                }

                const homesalePriceResp = await props.getHomesalePriceByRegion(regionName);
                if (homesalePriceResp.response) {
                setAvgHomesalePrice(parseFloat(homesalePriceResp.response.averagePrice.replace(/[$,]+/g,"")));
                }

                // let currentDate = new Date();
                // let fullRate = gsaResp.rates[0].rate[0].months.month.find((rt) => rt.number === (currentDate.getMonth() + 1));
                setPerDiemMealRate(gsaNationalMealRate);
                setPerDiemRate(gsaNationalLodgingRate);

                if (origin && origin.city && origin.state) {
                    const gsaOriginResp = await getGsaPerDiem(origin.city, origin.state, '2025');
                    const gsaOriginState = gsaOriginResp.rates[0].state;
                    let gsaOriginCity = gsaOriginResp.rates[0].rate[0].city;

                    let originRegionName = 'United States';
                    if (gsaOriginCity !== null && gsaOriginState !== null) {
                        gsaOriginCity = gsaOriginCity.includes(' / ') ? gsaOriginCity.split(' / ')[0] : gsaOriginCity;
                        originRegionName = `${gsaOriginCity}, ${gsaOriginState}`;
                    }

                    const homesalePriceOriginResp = await props.getHomesalePriceByRegion(originRegionName);
                    if (homesalePriceOriginResp.response) {
                        setAvgHomesalePriceOrigin(parseFloat(homesalePriceOriginResp.response.averagePrice.replace(/[$,]+/g,"")));
                    }

                    const perDiemSelectionId = estimateInfo?.savedBenefits ? estimateInfo.savedBenefits.find((sb) => sb.benefitNumber === 3)?.options.find((opt) => opt.optionNumber === 15)?.selectionId : null;
                    const numDaysBetweenFlights = perDiemSelectionId ? (perDiemSelectionId === 8 ? 1 : (perDiemSelectionId === 9 ? 2 : (perDiemSelectionId === 11 ? 4 : 3))) : 3;

                    let baseDate = new Date();
                    baseDate.setDate(baseDate.getDate() + 14);
                    const departureDate = baseDate.toISOString().split('T')[0];
                    baseDate.setDate(baseDate.getDate() + numDaysBetweenFlights);
                    const returnDate = baseDate.toISOString().split('T')[0];

                    let newDistance = await getDistance(origin, destination);
                    const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;

                    const flightCostResp = await props.getFlightPrice({
                        departureCity: gsaOriginCity ? gsaOriginCity : origin.city,
                        departureState: gsaOriginState,
                        destinationCity: gsaDestinationCity ? gsaDestinationCity : destination.city,
                        destinationState: gsaDestinationState,
                        departureDate: departureDate,
                        returnDate: returnDate,
                        mileage: newParsedDistance,
                    });

                    if (flightCostResp.response && flightCostResp.response.price) {
                        setFlightCost(parseFloat(flightCostResp.response.price.total.replace(/[$,]+/g,"")));
                    }
                } 
            }

            setIsUpdatingSelections(false);
        })();
    }, [destination, origin]);

    useEffect(() => {
        (async () => {
            if (origin && origin.formattedAddress && destination && destination.formattedAddress) {
                let newDistance = await getDistance(origin, destination);
                const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;
                setDistance(newParsedDistance);

                if (newParsedDistance > 0) {
                    const autoShipmentResp = await props.getAutoShipmentCost(newParsedDistance);
                    if (autoShipmentResp.response && autoShipmentResp.response.price) {
                        setAutoShipmentCost(parseFloat(autoShipmentResp.response.price));
                    }

                    const homeType = (estimateInfo.topLevelInputOneId === 1 || estimateInfo.topLevelInputOneId === 2) ? 2 : 1;
                
                    const packLoadMoveResp = await props.getPackLoadMovePrice( newParsedDistance, homeType, estimateInfo.topLevelInputTwoId );
                    if (packLoadMoveResp.response) {
                        setPackLoadCost(parseFloat(packLoadMoveResp.response.price.replace('$', '').replace(',', '')));
                        setThirtyDayStorageCost(parseFloat(packLoadMoveResp.response.thirtyDayStorage.replace('$', '').replace(',', '')));
                        setSixtyDayStorageCost(parseFloat(packLoadMoveResp.response.sixtyDayStorage.replace('$', '').replace(',', '')));
                    }
                }

                const tempLivingPriceResp = await props.getTempLivingPriceByRegion( destination.state, `${destination.city}, ${destination.state}`, estimateInfo.topLevelInputThreeId );
                setTempLivingDaysCost(parseFloat(tempLivingPriceResp.response ? tempLivingPriceResp.response.median.replace('$', '') : 0));
            }
        })();
    }, []);

    const staticBenefitsForCalculation = getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance);
    const grossUpAmount = getGrossUpAmount(staticBenefitsForCalculation, estimateInfo.savedBenefits, estimateInfo.topLevelInputFive, estimateInfo.topLevelInputSix, estimateInfo.topLevelInputSeven, estimateInfo.topLevelInputEight, estimateInfo.topLevelInputNine, avgHomesalePrice, avgHomesalePriceOrigin, estimateInfo.applyTaxGrossUp, getOptionCost, estimateInfo.grossUpPercentage);
    const totalEstimateAmount = getTotalEstimateAmount(staticBenefitsForCalculation, estimateInfo.savedBenefits, estimateInfo.topLevelInputFive, estimateInfo.topLevelInputSix, estimateInfo.topLevelInputSeven, estimateInfo.topLevelInputEight, estimateInfo.topLevelInputNine, avgHomesalePrice, avgHomesalePriceOrigin, estimateInfo.applyTaxGrossUp, getOptionCost, estimateInfo.grossUpPercentage);
    const policyName = (props.policies && props.policies.find((policy) => policy.policyId === estimateInfo.costEstimatePolicyId)) ? props.policies.find((policy) => policy.policyId === estimateInfo.costEstimatePolicyId).policyName : 'N/A';

    const today = new Date();
    
    return (
        <div>
            {isUpdatingSelections && (
                <Box className={classes.loadingOverlay}>
                    <LogoSpinner size="large" />
                </Box>
            )}
            <Box sx={{ backgroundColor: 'white', padding: '10px 0px 10px 10px' }}>
                <Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center', backgroundColor: '#de3f18', padding: '5px 0px 5px 5px' }}>
                        <Box sx={{ color: '#ffffff', fontSize: '14px'}}>The amounts provided are estimates only. Actual cost may vary.</Box>
                    </Box>
                    <Grid container direction="row" >
                        <Grid item xs={2}>
                            <Box sx={{ paddingTop: '10px' }}>
                                <TextField
                                    id="name"
                                    className={classes.textField}
                                    label="Transferee Name"
                                    value={transfereeName}
                                    variant="outlined"
                                    size="small"
                                    onChange={(e) => setTransfereeName(e.target.value)}
                                    disabled={true}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box sx={{ paddingTop: '10px' }}>
                                <TextField
                                    id="costEstimatePolicyId"
                                    select
                                    label="Cost Estimate Policy"
                                    className={classes.textField}
                                    value={costEstimatePolicyId}
                                    fullWidth={true}
                                    variant="outlined"
                                    size="small"
                                    disabled={true}
                                >
                                    {props.policies && props.policies.map((policy) => <MenuItem value={policy.policyId}>{policy.policyName}</MenuItem>)}
                                </TextField>
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box sx={{ paddingTop: '10px' }}>
                                <TextField
                                    id="costEstimate"
                                    select
                                    label="Ownership Status"
                                    className={classes.textField}
                                    onChange={(e) => setReloPolicy(e.target.value)}
                                    value={reloPolicy}
                                    fullWidth={true}
                                    variant="outlined"
                                    size="small"
                                    disabled={true}
                                >
                                    <MenuItem value={'Homeowner'} key={0}>Homeowner</MenuItem>
                                    <MenuItem value={'Renter'} key={1}>Renter</MenuItem>
                                </TextField>
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box sx={{ maxWidth: '200px' }}>
                                <GooglePlacesAutocompleteComponent
                                    initialValue={origin}
                                    value={origin.formattedAddress ? origin.formattedAddress : origin}
                                    label={'Origin Location'}
                                    onSelect={async (event, value) => {
                                        setOrigin(value);

                                        if (value && destination.length !== 0) {
                                            // Distance is returned in meters so we need to divide by 1609 to get miles.
                                            let newDistance = await getDistance(value, destination);
                                            const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;
                                            setDistance(newParsedDistance);

                                            if (newParsedDistance > 0) {
                                                const autoShipmentResp = await props.getAutoShipmentCost(newParsedDistance);
                                                if (autoShipmentResp.response && autoShipmentResp.response.price) {
                                                    setAutoShipmentCost(parseFloat(autoShipmentResp.response.price));
                                                }
                                            }
                                        }
                                    }}
                                    onInputEdit={async (event) => {
                                        setOrigin(event);
                                    }}
                                    onInputClear={(event) => {
                                        setOrigin('');
                                    }}
                                    // onFocus={onFocus}
                                    // onBlur={onBlur}
                                    disabled={true}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box sx={{ maxWidth: '200px' }}>
                                <GooglePlacesAutocompleteComponent
                                    initialValue={destination}
                                    value={destination.formattedAddress ?  destination.formattedAddress : destination}
                                    label={'Destination Location'}
                                    onSelect={async (event, value) => {
                                        setDestination(value);
                                        if (value && origin.length !== 0) {
                                            // Distance is returned in meters so we need to divide by 1609 to get miles.
                                            let newDistance = await getDistance(origin, value);
                                            const newParsedDistance = newDistance.value ? parseFloat(newDistance.value / 1609).toFixed(2) : 0;
                                            setDistance(newParsedDistance);

                                            if (newParsedDistance > 0) {
                                                const autoShipmentResp = await props.getAutoShipmentCost(newParsedDistance);
                                                if (autoShipmentResp.response && autoShipmentResp.response.price) {
                                                    setAutoShipmentCost(parseFloat(autoShipmentResp.response.price));
                                                }
                                            }
                                        }
                                    }}
                                    onInputEdit={(event) => setDestination(event)}
                                    onInputClear={(event) => {
                                        setDestination('');
                                    }}
                                    size="small"
                                    // onFocus={onFocus}
                                    // onBlur={onBlur}
                                    disabled={true}
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box sx={{ paddingTop: '5px' }}>
                                <Typography color="primary">{estimateId ? `Cost Estimate ID ${estimateId}` : 'New Cost Estimate'}</Typography>
                                <Typography color="secondary">Move Miles: {distance}</Typography>
                            </Box>
                        </Grid>
                        {/* <Grid item xs={2}>
                            <Box sx={{ paddingTop: '0px' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={isExecutive}
                                            onChange={(e) => setIsExecutive(!isExecutive)}
                                            size="small"
                                        />
                                    }
                                    label={'Is Executive'}
                                    disabled={true}
                                />
                            </Box>
                            <Box sx={{ paddingTop: '0px' }}>
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={hasSpouse}
                                            onChange={(e) => setHasSpouse(!hasSpouse)}
                                            size="small"
                                        />
                                    }
                                    label={'Traveling with SO'}
                                    disabled={true}
                                />
                            </Box>
                        </Grid> */}
                        <Grid item xs={2}>
                            <Box sx={{ paddingTop: '10px' }}>
                                <TextField
                                    id="accompanyingAdults"
                                    className={classes.textField}
                                    label="Accompanying Family Members"
                                    value={accompanyingAdults}
                                    variant="outlined"
                                    type="number"
                                    onChange={(e) => setAccompanyingAdults(e.target.value)}
                                    size="small"
                                    disabled={true}
                                />
                            </Box>
                        </Grid>

                        <Grid item xs={2}>
                            <Box sx={{ paddingTop: '10px' }}>
                                <TextField
                                    id="dateCreated"
                                    label="Date Created"
                                    type="date"
                                    value={`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() <= 9 ? '0' + today.getDate() : today.getDate()}`}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        className: classes.input,
                                    }}
                                    placeholder={'yyyy-mm-dd'}
                                    className={classes.textField}
                                    disabled={true}
                                    size="small"
                                />
                            </Box>
                        </Grid>
                        <Grid item xs={2}>
                            <Box sx={{ paddingTop: '10px' }}>
                                <TextField
                                    id="dateModified"
                                    label="Date Modified"
                                    type="date"
                                    value={`${today.getFullYear()}-${today.getMonth() + 1}-${today.getDate() <= 9 ? '0' + today.getDate() : today.getDate()}`}
                                    InputLabelProps={{
                                        shrink: true,
                                    }}
                                    InputProps={{
                                        className: classes.input,
                                    }}
                                    placeholder={'yyyy-mm-dd'}
                                    className={classes.textField}
                                    disabled={true}
                                    size="small"
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>

                <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'center', paddingTop: '20px', paddingBottom: '20px'}}>
                    <Box sx={{paddingTop: '5px'}}>
                        <SelectionsCostBar 
                            savedBenefits={estimateInfo.savedBenefits} 
                            benefits={getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance)} 
                            distance={distance} 
                            applyTaxGrossUp={estimateInfo.applyTaxGrossUp}
                            topLevelInputFive={estimateInfo.topLevelInputFive} 
                            topLevelInputSix={estimateInfo.topLevelInputSix} 
                            topLevelInputSeven={estimateInfo.topLevelInputSeven}
                            topLevelInputEight={estimateInfo.topLevelInputEight}
                            topLevelInputNine={estimateInfo.topLevelInputNine}
                            avgHomesalePrice={avgHomesalePrice}
                            avgHomesalePriceOrigin={avgHomesalePriceOrigin}
                            getOptionCost={getOptionCost}
                            grossUpPercentage={estimateInfo.grossUpPercentage}
                        />
                    </Box>
                    <Box sx={{ paddingLeft: '20px'}}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={estimateInfo.applyTaxGrossUp}
                                    // onChange={(e) => setApplyTaxGrossUp(!applyTaxGrossUp)}
                                    disabled={true}
                                    size="small"
                                />
                            }
                            label={`Apply Tax Gross Up (${estimateInfo.grossUpPercentage}%)`}
                        />
                    </Box>
                </Box>

                <Box sx={{ width: '100%', padding: '20px', paddingBottom: '40px' }}>
                    {estimateInfo.savedBenefits.map((sb) => {
                        let staticBenefit = getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance).find((b) => b.benefitNumber === sb.benefitNumber);

                        let totalBenefitCost = 0;

                        if (staticBenefit.customTotal) {
                            if (sb) {
                                totalBenefitCost = sb.cost;
                            } else {
                                totalBenefitCost = 0;
                            }
                        } else {
                            if (sb) {
                                totalBenefitCost = staticBenefit.options.filter((opt) => sb.options.find((csbo) => csbo.optionNumber === opt.optionNumber)).reduce((total, o) => total + getOptionCost(o, sb.options.find((csbo) => csbo.optionNumber === o.optionNumber), staticBenefit), 0);
                                totalBenefitCost += sb.customLineChecked ? Number(sb.customLineCost) : 0;
                            } else {
                                totalBenefitCost = staticBenefit.options.reduce((total, o) => total + (o.variable ? (props.distance * o.multiplier) : o.cost), 0);
                            }
                        }

                        let topLevelSelectionText = '';

                        if (staticBenefit.topLevelInputOne) {
                            const optionOneDetails = staticBenefit.topLevelInputOne.options.find((details) => details.id === estimateInfo.topLevelInputOneId);
                            const optionTwoDetails = staticBenefit.topLevelInputTwo.options.find((details) => details.id === estimateInfo.topLevelInputTwoId);
                            topLevelSelectionText = `(${optionOneDetails ? optionOneDetails.label : ''}, ${optionTwoDetails ? optionTwoDetails.label : ''})`;
                        } else if (staticBenefit.topLevelInputThree) {
                            const optionThreeDetails = staticBenefit.topLevelInputThree.options.find((details) => details.id === estimateInfo.topLevelInputThreeId);
                            topLevelSelectionText = `(${optionThreeDetails ? optionThreeDetails.label : ''})`;
                        } else if (staticBenefit.topLevelInputFour) {
                            const optionFourDetails = staticBenefit.topLevelInputFour.options.find((details) => details.id === estimateInfo.topLevelInputFourId);
                            topLevelSelectionText = `(${optionFourDetails ? optionFourDetails.label : ''})`;
                        }

                        return (
                            <Box>
                                <Grid container direction="row" >
                                    <Grid item xs={4}>
                                        <Box>
                                            <Typography color="primary">{staticBenefit.name}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                            <Typography color="primary">{topLevelSelectionText}</Typography>
                                        </Box>
                                    </Grid>
                                    <Grid item xs={4}>
                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <Typography variant="subtitle1">{displayCost(totalBenefitCost, CostUnit.CURRENCY)}</Typography>
                                        </Box>
                                    </Grid>
                                </Grid>

                                <hr/>

                                <Box sx={{paddingBottom: '20px'}}>
                                    {sb.options.map((savedOpt) => {
                                        let staticOpt = staticBenefit.options.find((opt) => opt.optionNumber === savedOpt.optionNumber);
                                        if (staticOpt) {
                                            let optionText = '';
                                            let selectionText = '';
                                            if (staticOpt.selections && savedOpt && staticOpt.selections.find((os) => os.selectionId === savedOpt.selectionId)) {
                                                optionText = staticOpt.description;
                                                selectionText = `(${staticOpt.selections.find((os) => os.selectionId === savedOpt.selectionId).text})`;
                                            } else if (savedOpt && savedOpt.customDescription) {
                                                optionText = savedOpt.customDescription;
                                            } else if (savedOpt && savedOpt.selectionId && staticOpt.freeNumberField) {
                                                optionText = staticOpt.description;
                                                selectionText = `(${savedOpt.selectionId} ${staticOpt.freeNumberMultiplier})`;
                                            } else if (savedOpt && staticOpt.optionNumber === 21 && estimateInfo.topLevelInputFive) {
                                                optionText = 'Direct reimbursement (Subject to gross up)';
                                            } else if (staticBenefit.customTotal) {
                                                selectionText = sb.isTaxable ? '(Grossed Up)' : '(Not Grossed Up)';
                                            } else {
                                                optionText = staticOpt.description;
                                            }

                                            return (
                                                <Grid container direction="row" >
                                                    <Grid item xs={4}>
                                                        <Box>
                                                            <Typography color="secondary">{optionText}</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                                                            <Typography color="secondary">{selectionText}</Typography>
                                                        </Box>
                                                    </Grid>
                                                    <Grid item xs={4}>
                                                        <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                                            {!staticOpt.customTotal && (
                                                                <Typography variant="caption">{displayCost(getOptionCost(staticOpt, savedOpt, staticBenefit), CostUnit.CURRENCY)}</Typography>
                                                            )}
                                                            {staticOpt.customTotal && (
                                                                <Typography variant="caption">{displayCost(Number(sb.cost), CostUnit.CURRENCY)}</Typography>
                                                            )}
                                                        </Box>
                                                    </Grid>
                                                </Grid>
                                            )
                                        }
                                    })}

                                    {sb && sb.customLineChecked && (
                                        <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                            <Typography color="secondary">{sb.customLineDescription} </Typography>
                                            <Typography variant="caption">{displayCost(Number(sb.customLineCost), CostUnit.CURRENCY)}</Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Box>
                        )
                    })}

                    {estimateInfo.applyTaxGrossUp && (
                        <Box>
                            <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                <Typography color="primary">Gross Up Amount</Typography>
                                <Typography variant="subtitle1">{displayCost(grossUpAmount, CostUnit.CURRENCY)}</Typography>
                            </Box>

                            <hr/>

                            <Box sx={{ paddingBottom: '20px' }} />
                        </Box>
                    )}
                </Box>

                {/* <BenefitSelections reloPolicy={reloPolicy} distance={distance} estimateInfo={estimateInfo} saveEstimate={saveEstimate} exportEstimate={exportEstimate} generateAuth={generateAuth}/> */}
            </Box>

            <Box sx={{ position: 'fixed', zIndex: 4, bottom: 0, backgroundColor: 'white', padding: '10px 0px 10px 10px', width: props.drawerOpen ? 'calc(100% - 240px)' : 'calc(100% - 60px)' }}>
                <Paper>
                    <Box p={2.5}>
                        <Grid container direction="row">
                            <Grid item xs={4}>
                                <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                                    <Typography variant="h6">Export Type</Typography>
                                </Box>        
                            </Grid>
                            <Grid item xs={4} container justify="center">

                            </Grid>
                            <Grid item xs={4} container justify="flex-end" alignItems="flex-start">
                                {!isUpdatingSelections && (
                                    <Box sx={{marginTop: '10px'}}>
                                        <Button 
                                        size="small"
                                        color="secondary" 
                                        className={classes.button} 
                                        onClick={() => props.history.push(`/estimates/${props.match.params.estimateId}`)}
                                        >
                                            Back to Editor
                                        </Button>
                                        <Button 
                                            variant="contained" 
                                            size="small"
                                            color="primary" 
                                            className={classes.longButton} 
                                            onClick={() => 
                                                exportToExcelWithStyles(
                                                    estimateInfo.savedBenefits, 
                                                    getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance), 
                                                    `Cost Estimate ${props.match.params.estimateId}`, 
                                                    getOptionCost, 
                                                    totalEstimateAmount,
                                                    grossUpAmount,
                                                    estimateInfo,
                                                    distance,
                                                    policyName
                                                )
                                            }
                                        >
                                            Export as Excel
                                        </Button>

                                        <PDFDownloadLink document={
                                            <DownloadableDoc 
                                                estimateInfo={estimateInfo} 
                                                savedBenefits={estimateInfo.savedBenefits} 
                                                benefits={getBenefits(perDiemRate, perDiemMealRate, avgHomesalePrice, avgHomesalePriceOrigin, flightCost, homefindingDays, autoShipmentCost, distance)} 
                                                distance={distance} 
                                                applyTaxGrossUp={estimateInfo.applyTaxGrossUp} 
                                                perDiemRate={perDiemRate}
                                                perDiemMealRate={perDiemMealRate}
                                                avgHomesalePrice={avgHomesalePrice}
                                                avgHomesalePriceOrigin={avgHomesalePriceOrigin}
                                                flightCost={flightCost}
                                                homefindingDays={homefindingDays}
                                                autoShipmentCost={autoShipmentCost}
                                                tempLivingDaysCost={tempLivingDaysCost}
                                                packLoadCost={packLoadCost}
                                                topLevelInputFourId={estimateInfo.topLevelInputFourId}
                                                topLevelInputFive={estimateInfo.topLevelInputFive}
                                                topLevelInputSix={estimateInfo.topLevelInputSix}
                                                topLevelInputSeven={estimateInfo.topLevelInputSeven}
                                                topLevelInputEight={estimateInfo.topLevelInputEight}
                                                topLevelInputNine={estimateInfo.topLevelInputNine}
                                                grossUpAmount={grossUpAmount}
                                                getOptionCost={getOptionCost}
                                                grossUpPercentage={estimateInfo.grossUpPercentage}
                                            />
                                        } fileName="Estimate Summary.pdf">
                                            {({ blob, url, loading, error }) => {
                                                if (loading) {
                                                return 'Loading document...';
                                                } else if (error) {
                                                console.log('Error generating PDF:', error);
                                                return 'Error generating document...';
                                                } else {
                                                return <Button variant="contained" size="small" color="primary" className={classes.longButton} >Export as PDF</Button>;
                                                }
                                            }}
                                        </PDFDownloadLink>

                                    </Box>
                                )}
                                {isUpdatingSelections && (
                                    <Box sx={{marginTop: '10px'}}>
                                        <LogoSpinner size="small" />
                                    </Box>
                                )}
                            </Grid>
                        </Grid>
                    </Box>
                </Paper>
            </Box>
        </div>
    );
  }
  
  const mapStateToProps = (state) => {
    return {
      authorizationSearchResults: state.transferees.get('authorizationSearchResults'),
      estimates: state.estimator.get('estimates'),
      drawerOpen: state.layout.get('drawerOpen'),
      policies: state.estimator.get('policies'),
    };
  };
  
  export default withRouter(
    connect(mapStateToProps, {
      setPageTitle,
      showToast,
      setEstimations,
      getHomesalePriceByRegion,
      getFlightPrice,
      getAutoShipmentCost,
      getTempLivingPriceByRegion,
      getPackLoadMovePrice
    })(ExportPage),
  );
  